import { motion as Motion } from "motion/react";
import styles from "./StepIndicator.module.scss";

const LABELS = ["Dados pessoais", "Viagem e hospedagem", "Termos e presença"];

function StepIndicator({ currentStep }) {
  return (
    <nav className={styles.wrapper} aria-label="Progresso do cadastro">
      <ol className={styles.steps}>
        {LABELS.map((label, index) => {
          const step = index + 1;
          return (
            <li
              key={label}
              className={styles.step}
              aria-current={step === currentStep ? "step" : undefined}
            >
              <span className={styles.base} aria-hidden="true" />
              <Motion.span
                className={styles.fill}
                initial={false}
                animate={{ width: step <= currentStep ? "100%" : "0%" }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                aria-hidden="true"
              />
              <span className="srOnly">
                Etapa {step}: {label}{step === currentStep ? ", atual" : ""}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default StepIndicator;
